import Vue from 'vue'

import Alert from './alert/Alert'
import Breadcrumb from './breadcrumb/Breadcrumb'
import Buttons from './buttons/Buttons'
import Chosen from './chosen/Chosen'
import DataTable from './datatable/DataTable'
import DatePicker from './datepicker/Datepicker'
import Loader from './loader/Loader'
import Modal from './modal/ModalDelete'
import Table from './table/Table'
import Tables from './tables/Tables'
import TagsInput from '@johmun/vue-tags-input'
import Toast from './toast/Toast'

Vue.component('Alert', Alert)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('Button', Buttons)
Vue.component('Chosen', Chosen)
Vue.component('DataTable', DataTable)
Vue.component('DatePicker', DatePicker)
Vue.component('Loader', Loader)
Vue.component('Modal', Modal)
Vue.component('Table', Table)
Vue.component('Tables', Tables)
Vue.component('TagsInput', TagsInput)
Vue.component('Toast', Toast)



// WEBPACK FOOTER //
// ./src/components/index.js